/* eslint-disable no-continue */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useCallback, useMemo, useState, useRef, useEffect } from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { Formik, Form, Field } from "formik";
import { withFormikDevtools } from "formik-devtools-extension";
import { isProduction } from "src/config/index";
import PropTypes from "prop-types";
import { useLocation } from "react-router";
// import { DATE_TIME_FORMAT } from 'src/constants/CommonConstants';
import FormikCreateSearchClear from "src/components/formik/FormikCreateSearchClear";
import FormikDateTimePicker from "src/components/formik/FormikDateTimePicker";
import Table from "src/components/table/Table";
import { set } from "lodash";
import { getEndOfDay, getStartOfDay } from "src/utils/DadeUtils";
import {
  caseEditAction,
  caseResetAction,
  caseSearchAction,
} from "../case-container/actions/CaseActions";
import { headerShowAction } from "../header-container/actions/HeaderActions";
import RoutingUtil from "src/utils/RoutingUtil";
import OpenNewTabLink from "src/components/OpenNewTabLink";
import { userSearchAPI } from "src/api/UserApi";
import {
  PRODUCT_CATEGORY_TYPES_LIST,
  CAR_LOAN_TYPE_LIST,
  USED_CAR_LOAN_TYPE_LIST,
  ProductCategoryTypesData,
  DAYS_LEFT_TYPES_LIST,
} from "../product-container/ProductConstants";
import CompanyDropDown from "src/business-components/CompanyDropDown";
import UserDropDown from "src/business-components/UserDropDown";
import CommissionManagerDropDown from "src/business-components/CommissionManagerDropDown";
import FormikSelect from "src/components/formik/FormikSelect";
import { PAYOUT } from "../company-container/CompanyConstants";
import FormikCheckBox from "src/components/formik/FormikCheckBox";
import { alertApi, caseInvoiceCreateAPI } from "src/api/CaseApi";
import LinkComponent from "src/components/LinkComponent";
import { Route, Switch } from "react-router-dom";
import Invoice from "./Invoice";
import { useHistory } from "react-router";
import { commissionSearchAction } from "../commission-container/actions/CommissionActions";
import { commissionSearchAPI } from "src/api/CommissionApi";
import CustomerDropDown from "src/business-components/CustomerDropDown";
import FormikInput from "src/components/formik/FormikInput";
import { getGSTCalc, getPayout, getTotalAmount } from "src/utils/CommonUtils";
import { EMPLOYMENT_TYPES_LIST } from "../user-container/UserConstants";
import { DATA_TYPE, DATE_TIME_FORMAT } from "src/constants/CommonConstants";
import { remarkSearchAPI } from "src/api/RemarkApi";
import { ExportReactCSV } from "src/components/excel/ExportReactCSV";
import { excelCaseSearchAction } from "../excel-container/actions/ExcelActions";


const RenderFilters = (props) => {
  // DEV TOOL
  if (!isProduction()) {
    withFormikDevtools(props);
  }

  const {
    // errors,
    // touched,
    isSubmitting,
    onClear,
    // forceRefreshSearchContainer,
    resetForm,
    values,
    activityList,
    userType,
    ExportInExcel,
    handleChange,
    generateInvoice,
    history,
    onPageChange,
    alertModalClass,
    alertDisplay,
    openAlertDialog,
    viewRemarks,
    editClick,
    grossAmount,
    grossODPremium,
    customerAddress,
  } = props;

  //Deepcopy of EMPLOYMENT_TYPES_LIST
  const Employment_List = JSON.parse(JSON.stringify(EMPLOYMENT_TYPES_LIST));
  Employment_List.push({
    value: "onroll&dsa",
    label: "Onroll&DSA",
  });

  return (
    <div>
      <div
        style={{ justifyContent: "center", display: "flex", padding: "20px" }}
      >
        <h2>Insurance Renewal Report</h2>
      </div>
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Search Filters</h5>
          <Form>
            <div className="form-row">
              <div className="form-group col-md-3">
                <label>Category</label>
                {/* <FormikSelect
                  items={PRODUCT_CATEGORY_TYPES_LIST}
                  // value={productCategory.VEHICLE_INSURANCE}
                  name="productCategory"
                  className="form-control"
                /> */}
                <Field
                  type="text"
                  className="form-control"
                  disabled
                  value="Insurance"
                  name="productCategory"
                  initialValue="VEHICLE_INSURANCE"
                />

              </div>
              {values.productCategory === "CAR_LOAN" && (
                <div className="form-group col-md-3">
                  <label>Loan Type</label>
                  <FormikSelect
                    items={CAR_LOAN_TYPE_LIST}
                    name="loanType"
                    className="form-control"
                  />
                </div>
              )}
              {values.productCategory === "CAR_LOAN" &&
                values.loanType === "USED" && (
                  <div className="form-group col-md-3">
                    <label>Used Car Loan Type</label>
                    <FormikSelect
                      items={USED_CAR_LOAN_TYPE_LIST}
                      name="usedCarLoanType"
                      className="form-control"
                    />
                  </div>
                )}
              <div className="form-group col-md-3">
                <label>From Date</label>
                <FormikDateTimePicker
                  name="CaseFromDate"
                  className="form-control"
                  disableClock
                  format="dd-MM-y"
                  disabled={Boolean(values.FilterCommissionId)}
                />
              </div>
              <div className="form-group col-md-3">
                <label>To Date</label>
                <FormikDateTimePicker
                  name="CaseToDate"
                  className="form-control"
                  disableClock
                  format="dd-MM-y"
                  disabled={Boolean(values.FilterCommissionId)}
                />
              </div>
              <div className="form-group col-md-3">
                <label>Company</label>
                <CompanyDropDown name="companyId" value={values.companyId} />
              </div>
              <div className="form-group col-md-3">
                <label>Assigned Agent</label>
                <UserDropDown name="agentId" value={values.agentId} />
              </div>
              <div className="form-group col-md-3">
                <label>Reporting Manager</label>
                <UserDropDown
                  name="reportingManagerId"
                  value={values.reportingManagerId}
                />
              </div>

              <div className="form-group col-md-3">
                <label>Customer</label>
                <CustomerDropDown name="customerId" value={values.customerId} />
              </div>
              <div className="form-group col-md-3">
                <label>Vehicle Number</label>
                <FormikInput
                  name="vehicleNumber"
                  type="text"
                  placeholder="enter Vehicle Number for filter e.g DLB64620"
                  className="form-control"
                />
              </div>
              <div className="form-group col-md-3">
                <label>Employment Type</label>
                <FormikSelect
                  items={Employment_List}
                  name="employmentType"
                  className="form-control"
                />
              </div>
              <div className="form-group col-md-3">
                <label>Policy Number</label>
                <FormikInput
                  name="LoanPolicyNumber"
                  type="text"
                  placeholder="Policy Number"
                  value={values.LoanPolicyNumber}
                  className="form-control"
                />
              </div>
              {/* <div className="form-group col-md-3">
                <label>Days Left</label>
                <FormikSelect
                  items={DAYS_LEFT_TYPES_LIST}
                  name="chooseDaysLeft"
                  className="form-control"
                />
              </div> */}
            </div>

            <div className="text-center py-4 mt-3">
              <FormikCreateSearchClear
                isSubmitting={isSubmitting}
                onClear={onClear}
                resetForm={resetForm}
                submitButtonText="Search"
                submitScope="reports.insurance_alert_list.search"
              />
            </div>
          </Form>
        </div>
      </div>
      <div className="border-top my-3" />
      <div className="card mt-3">
        <div className="card-body">
          <h5 className="card-title">
            Search Results
            <ExportReactCSV
              csvData={ExportInExcel}
              fileName={"Insurance-Renewal-Alert-" + new Date().toLocaleDateString()}
            />
          </h5>
          {/* <div className="mb-2 border p-2 float-left">
            <span className="mr-2 border badge badge-secondary status-Total mb-2">
              <div>
                <label>Gross Amount</label>
                <div>
                  <input className="text-center font-weight-bold text-black" type="text" value={grossAmount} disabled
                  />
                </div>
              </div>
            </span>
            <span className="mr-2 border badge badge-secondary status-Total mb-2">
              <div>
                <label>Gross OD Premium</label>
                <div>
                  <input className="text-center font-weight-bold text-black" type="text" value={grossODPremium} disabled
                  />
                </div>
              </div>
            </span>
          </div> */}
          <Table
            recordsPerPage={50}
            onPageChange={onPageChange}
            searchData={{
              data: activityList.data,
              count: activityList.count,
              currentPage: activityList.currentPageIndex,
            }}
            columns={{
              group: [
                {
                  display: "Name of Customer",
                  path: "customerName",
                },
                {
                  display: "Address",
                  path: "customerAddress",
                },
                {
                  display: "Assigned Agent Name",
                  path: "agentName",
                },
                {
                  display: "Reporting Manager Name",
                  path: [
                    "reportingManagerId.personalInfo.firstName",
                    "reportingManagerId.personalInfo.lastName",
                  ],
                },
                {
                  display: "Customer Mobile",
                  path: "customerId.phone",
                },
                {
                  display: "Manufacturer/Company",
                  path: "companyId.companyName",
                },
                {
                  display: "Business Type",
                  path: "vehicleStatus",
                },
                {
                  display: "Vehicle Name",
                  path: "meta.vehicleProductId.productName",
                },
                {
                  display: "Policy Issue Date",
                  type: Date,
                  format: DATE_TIME_FORMAT.DATE,
                  path: "coverNotes.cn_date",
                },
                {
                  display: "Model Year",
                  path: "meta.vehicleModelYear",
                },
                {
                  display: "Vehicle Number",
                  path: "meta.vehicleNumber",
                },
                // {
                //   display: "Engine Number",
                //   path: "meta.engineNumber",
                // },
                // {
                //   display: "Chasis Number",
                //   path: "meta.chasisNumber",
                // },
                {
                  display: "Policy Number",
                  path: "coverNotes.cn_number",
                },
                {
                  display: "Effective Date",
                  type: Date,
                  format: DATE_TIME_FORMAT.DATE,
                  path: "coverNotes.effective_date",
                },
                {
                  display: "Expiry Date",
                  type: Date,
                  format: DATE_TIME_FORMAT.DATE,
                  path: "expiryDate",
                },
                {
                  display: "Third-Party Expiry Date",
                  type: Date,
                  format: DATE_TIME_FORMAT.DATE,
                  path: "coverNotes.third_party_exp_date",
                },
                {
                  display: "Policy Type",
                  path: "policyType.masterName",
                },
                // {
                //   display: "Vehicle IDV Value",
                //   path: "coverNotes.vehicleIdvValue",
                // },
                {
                  display: "Total Policy Premium",
                  path: "coverNotes.totalPolicyPremium",
                },
                {
                  display: "NCB (%)",
                  path: "coverNotes.ncbPercentage",
                },
                // {
                //   display: "OD Discount (%)",
                //   path: "coverNotes.odDiscountPercentage",
                // },
                {
                  display: "Insurance OD Premium",
                  path: "coverNotes.odPremium",
                },
                {
                  display: "LOS No.",
                  path: "coverNotes.losNo",
                },
                {
                  display: "Insu. Agent Code",
                  path: "coverNotes.InsUAgentCode",
                },
                {
                  display: "Created By",
                  path: "by.personalInfo.firstName",
                },
                {
                  display: "Days Left",
                  path: "dayCount",
                },
              ],
            }}
            rowColoring={[
              // list should be priority wise
              {
                reason: "Pending",
                rowClass: "status-pending",
                shouldApply: (record) => record.isPending,
              },
              {
                reason: "Critical",
                rowClass: "status-critical",
                shouldApply: (record) => record.isCritical,
              },
            ]}
            customActions={[
              {
                heading: "View Remarks",
                Render: ({ record }) => {
                  return (
                    <LinkComponent onClick={() => viewRemarks(record._id)}>
                      <i className="fas fa-eye " />
                    </LinkComponent>
                  );
                },
              },
              {
                heading: "View Case Manager",
                Render: ({ record }) => {
                  return (
                    <LinkComponent onClick={() => editClick(record)}>
                      <i className="fas fa-pen" />
                    </LinkComponent>
                  );
                },
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

RenderFilters.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  onClear: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  values: PropTypes.any.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  // activityList: PropTypes.Object.isRequired,
};

// setting submit button state after submitting
const filterDefaultValues = {
  verifierId: "",
  clientId: "",
  branchId: "",
  CaseFromDate: null, //new Date(new Date().getFullYear(), new Date().getMonth(), 1),
  CaseToDate: null, //new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
  caseId: "",
  caseStatus: "",
  overAllcaseStatus: "",
  LoanPolicyNumber: "",
};

const RptInsuranceAlertList = () => {
  useEffect(() => {
    let where = {};
    const currentYear = new Date().getFullYear();
    const previousYear = currentYear - 2; // Subtract 2 years for the from date
    const fromDate = new Date(`${previousYear}-01-01`); // January 1st of two years ago
    const currentDate = new Date();
    const futureDate = new Date(currentDate.setFullYear(currentDate.getFullYear() - 1)); // Set the future date to one year before the current date
    futureDate.setDate(futureDate.getDate() + 60); // Add 60 days to the future date
  
    set(where, "coverNotes.effective_date", { $lte: futureDate, $gte: fromDate });
    console.log('where', where);
  
    dispatch(
      caseSearchAction({
        where,
        currentPage: 0,
        sortBy: "ts",
        sortOrder: -1,
        fullTextSearch: false,
        pageLength: 50,
      })
    );
  }, []);;
  
  const [filterInitialValues, setFilterInitialValues] = useState({
    ...filterDefaultValues,
  });

  const [currentProductCategory, setProductCategory] = useState(
    ProductCategoryTypesData.VEHICLE_INSURANCE
  );

  const [currentCompany, setCurrentCompany] = useState();

  const [currentActivityAssignedDateTill, setCurrentActivityAssignedDateTill] =
    useState();

  const [currentActivityAssignedDateFrom, setCurrentActivityAssignedDateFrom] =
    useState();

  const [invoiceInitialValues, setInvoiceInitialValues] = useState([]);

  const [where, setWhere] = useState({});

  const [currentPageIndex, setCurrentPageIndex] = useState(0);

  const [alertModalClass, setAlertModalClass] = useState(false);
  const [alertDisplay, setAlertDisplay] = useState(false);

  const [remarksModalClass, setRemarksModalClass] = useState(false);
  const [remarksDisplay, setRemarksDisplay] = useState(false);
  const [remarksDetails, setRemarksDetails] = useState([]);
  const [grossAmount, setGrossAmount] = useState(0)
  const [grossODPremium, setGrossODPremium] = useState(0)
  const [daysLeftToMinus, setDaysLeftToMinus] = useState(60)

  const [commissionMaster, setCommissionMaster] = useState({ slab: [] });

  const openAlertDialog = () => {
    setRemarksDisplay("block");
    setRemarksModalClass("show");
    if (document.body.style.overflow !== "hidden") {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "scroll";
    }
  };
  const closeAlertDialog = () => {
    setRemarksModalClass("none");
    setRemarksDisplay("");
    if (document.body.style.overflow !== "scroll") {
      document.body.style.overflow = "scroll";
    } else {
      document.body.style.overflow = "hidden";
    }
  };

  let data = [];
  // REDUX
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const isRenualAlert =
    location.pathname.split("/").pop() === "insurance-renewal-alert"
      ? true
      : false;

  const {
    search: { data: searchResults, count },
  } = useSelector((state) => state.CaseReducer, shallowEqual);

  const {
    search: { data: excelSearchResults, excelCount },
  } = useSelector((state) => state.ExcelReducer, shallowEqual);

  const { userType, userId } = useSelector(
    (state) => state.AuthReducer,
    shallowEqual
  );
  let no = 1
  // Function to check if the effective date has passed over 304 days
  const hasPassedDays = (effectiveDate) => {
    const currentDate = new Date();
    const effectiveDateObj = new Date(effectiveDate);
    const timeDifference = currentDate.getTime() - effectiveDateObj.getTime();
    const effectiveDateDays = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const daysToCompare = 365 - daysLeftToMinus;
    // console.log('effectiveDateDays', effectiveDateDays)
    return effectiveDateDays >= daysToCompare;
  };

  //filter to create a new array with items that meet the condition
  const filteredResults = searchResults.filter((item) => {
    const effectiveDate = new Date(item.coverNotes.effective_date);
    // console.log('effectiveDate', effectiveDate)
    if (!hasPassedDays(effectiveDate)) {
      return false; // Exclude items that haven't passed 304 days
    } else {
      return true; // Include items that have completed 304 days
    }
  });

  const getCommissionDetails = (totalGrossAmt) => {
    let commissionDT = []; //{ commissionTarget: 0, tillNow: 0, Status: "Short" };
    commissionMaster.slab.map((slab, index) => {
      // const lastTarget = commissionMaster.slab[index];
      const status = totalGrossAmt >= slab.target ? "Completed" : "Short";
      const amount = slab.target + (slab.target * slab.reward) / 100;
      commissionDT.push({
        commissionTarget: slab.target,
        tillNow: totalGrossAmt,
        reward: slab.reward,
        amount,
        status,
        isRewardPercentage: slab.isRewardPercentage,
      });
    });
    return commissionDT;
  };
 
  const activitiesFromSearch = useMemo(() => {
    if (!searchResults) {
      return [];
    }

    const PrepairData = [];
    let totalGrossAmt = 0;
    let totalGrossODPremium = 0;
    let customerAddress="NA"
    searchResults.forEach((caseInfo) => {
      if(caseInfo?.caseType=="CORPORATE"){
        customerAddress = caseInfo?.customerId?.companyAddress
      }else{
        customerAddress = caseInfo?.customerId?.presentAddress
      }
      const CrossSellAmount = caseInfo.meta.crossSaleAmount || 0;
      const gstCalc = caseInfo.companyId.GSTCalc;
      const DueAmount = getPayout(caseInfo, "Due");
      const payoutAmount = getPayout(caseInfo, "Payout");
      const difference = payoutAmount - DueAmount;
      const GSTEncExc = getGSTCalc(DueAmount, gstCalc);
      const agentName =
        caseInfo.agentId.personalInfo.firstName +
        " " +
        caseInfo.agentId.personalInfo.lastName +
        "-" +
        caseInfo.agentId.employmentType;
      const amount = caseInfo.meta.loanAmount - CrossSellAmount;
      const paymentAmount = getTotalAmount(caseInfo.paymentDetails);
      const receiptAmount = getTotalAmount(caseInfo.recieptDetails);
      const customerName = `${caseInfo.customerId.firstName} ${caseInfo.customerId.lastName}`;
      totalGrossAmt += caseInfo.coverNotes.totalPolicyPremium || 0;
      setGrossAmount(totalGrossAmt);
      totalGrossODPremium += caseInfo.coverNotes.odPremium || 0;
      setGrossODPremium(totalGrossODPremium)
      totalGrossAmt += caseInfo.meta.grossLoanAmount || 0;
      const loanType =
        caseInfo.meta.loanType + " " + (caseInfo.meta?.usedCarType || "");
      const currentDate = new Date();
      const effectiveDate = new Date(caseInfo.coverNotes.effective_date);
      const expiryDate = new Date(effectiveDate.getFullYear() + 1, effectiveDate.getMonth(), effectiveDate.getDate() - 1);
      const timeDifference = Math.max(0, expiryDate.getTime() - currentDate.getTime());

      const dayCount = Math.ceil(timeDifference / (1000 * 3600 * 24));

      const isPending =
        new Date() - new Date(dayCount) >= 30 * 24 * 60 * 60 * 1000 &&
        new Date() - new Date(dayCount) <= 60 * 24 * 60 * 60 * 1000;
      const isCritical =
        new Date() - new Date(dayCount) >= 61 * 24 * 60 * 60 * 1000;

      PrepairData.push({
        ...caseInfo,
        difference,
        payoutAmount,
        DueAmount,
        CrossSellAmount,
        GSTEncExc,
        agentName,
        amount,
        paymentAmount,
        receiptAmount,
        loanType,
        customerName,
        customerAddress,
        isPending,
        isCritical,
        dayCount,
        expiryDate,
      });
    });

    const commissionDetails = getCommissionDetails(totalGrossAmt);
    const results = {
      data: PrepairData,
      count,
      currentPageIndex,
      commissionDetails,
    };

    return results;
  }, [
    searchResults,
    currentProductCategory,
    currentActivityAssignedDateFrom,
    currentActivityAssignedDateTill,
    currentCompany,
    currentPageIndex,
  ]);

  // PAGE CHANGE
  const onPageChange = useCallback(
    (currentPage) => {
      setCurrentPageIndex(currentPage);
      dispatch(
        caseSearchAction({
          where,
          currentPage,
          fullTextSearch: true,
        })
      );
    },
    [
      dispatch,
      caseSearchAction,
      where,
      currentPageIndex,
      // currentPage,
      // where,
      // fullTextSearch,
    ]
  );

  const onSearchSubmit = useCallback(
    async (values, formikUtils) => {
      formikUtils.setSubmitting(false);
      const {
        productCategory,
        loanType,
        usedCarLoanType,
        CaseFromDate,
        CaseToDate,
        companyId,
        agentId,
        reportingManagerId,
        FilterCommissionId,
        customerId,
        vehicleNumber,
        employmentType,
        LoanPolicyNumber,
        chooseDaysLeft,
        customerAddress,
      } = values;
      if (
        // THERE MUST BE AT LEAST ONE FILTER
        [
          productCategory,
          loanType,
          usedCarLoanType,
          CaseFromDate,
          CaseToDate,
          companyId,
          FilterCommissionId,
          agentId,
          reportingManagerId,
          customerId,
          vehicleNumber,
          employmentType,
          LoanPolicyNumber,
        ].filter((item) => !!item).length < 1
      ) {
        dispatch(
          headerShowAction({
            data: "There must at least one filter to be added.",
          })
        );
        return;
      }

      let where = {};
      //days left
      // if (chooseDaysLeft) {
      //   console.log("choose", chooseDaysLeft);
      //   if (chooseDaysLeft === 'DAYS_30') {
      //     setDaysLeftToMinus(30);
      //   } else if (chooseDaysLeft === 'DAYS_60') {
      //     setDaysLeftToMinus(60);
      //   }
      // }    
       //days left
      // if (chooseDaysLeft) {
      //      if (chooseDaysLeft === 'DAYS_30') {
      //       calculateDates();
      //   } 
 
      // }

      // product Category
      if (productCategory) {
        set(where, "productCategory", productCategory);
        setProductCategory(productCategory);
      } else {
        setProductCategory(null);
      }
      // set(where, "productCategory", "VEHICLE_INSURANCE");

      if (loanType) {
        set(where, "meta.loanType", loanType);
      }
      if (usedCarLoanType) set(where, "meta.usedCarType", usedCarLoanType);
      // company
      if (companyId) {
        set(where, "companyId", companyId);
        setCurrentCompany(companyId);
      } else {
        setCurrentCompany(null);
      }

      // FROM
      if (CaseFromDate && !Number.isNaN(CaseFromDate.getTime())) {
        let CaseFrom = new Date(CaseFromDate.getFullYear() - 1, CaseFromDate.getMonth(), CaseFromDate.getDate() + 1);

        const fromDate = getStartOfDay(CaseFrom);

        setCurrentActivityAssignedDateFrom(CaseFrom);

        set(where, "coverNotes.effective_date", { $gte: fromDate });
      } else {
        setCurrentActivityAssignedDateFrom(null);
      }

      // TILL
      if (CaseToDate && !Number.isNaN(CaseToDate.getTime())) {

        let CaseTo = new Date(CaseToDate.getFullYear() - 1, CaseToDate.getMonth(), CaseToDate.getDate() + 1);
        let CaseFrom = new Date(CaseFromDate.getFullYear() - 1, CaseFromDate.getMonth(), CaseFromDate.getDate() + 1);

        const tillDate = getEndOfDay(CaseTo);
        const fromDate = getStartOfDay(CaseFrom);

        setCurrentActivityAssignedDateTill(CaseTo);

        set(where, "coverNotes.effective_date", { $lte: tillDate });
        if (fromDate)
          set(where, "coverNotes.effective_date", { $lte: tillDate, $gte: fromDate });
      } else {
        setCurrentActivityAssignedDateTill(null);
      }

      // if(isRenualAlert)
      // {
      //   const currentDate = new Date();
      //   currentDate.setDate(currentDate.getDate() + 60);
      //   set(where, "coverNotes.expire_date", { $lte: currentDate });
      // }

      // CLIENT
      if (agentId) {
        where.agentId = agentId;
      }
      if (reportingManagerId) {
        where.reportingManagerId = reportingManagerId;
      }
      //CUSTOMER
      if (customerId) {
        where.customerId = customerId;
      }
      //vehicleNumber
      if (vehicleNumber) {
        set(where, "meta.vehicleNumber", vehicleNumber);
      }
      // CommissionId
      if (FilterCommissionId) {
        where = {};
        set(where, "invoiceDetails.commissionId", FilterCommissionId);
        const commissionId = { _id: FilterCommissionId };
        let {
          data: {
            data: { data: commissionMasterDT },
          },
        } = await commissionSearchAPI({
          where: {
            ...commissionId,
          },
          autopopulate: false,
        });
        commissionMasterDT = commissionMasterDT[0];
        setCommissionMaster(commissionMasterDT);
        const fromDate = getStartOfDay(commissionMasterDT.FromDate);
        set(where, "ts", { $gte: fromDate });
        setCurrentActivityAssignedDateFrom(fromDate);
        values.CaseFromDate = fromDate;
        const tillDate = getEndOfDay(commissionMasterDT.ToDate);
        set(where, "ts", { $lte: tillDate });
        setCurrentActivityAssignedDateTill(tillDate);
        values.CaseToDate = tillDate;

        if (commissionMasterDT.loanType)
          set(where, "loanType", commissionMasterDT.loanType);
        if (
          commissionMasterDT.loanType == "USED" &&
          commissionMasterDT.usedCarType
        )
          set(where, "usedCarType", commissionMasterDT.usedCarType);
      } else {
        // setCurrentCompany(null);
      }
      if (employmentType) {
        let userTypes = [];
        if (employmentType === "onroll&dsa") {
          // If both onRoll and dsa types are selected together, set it for the search
          userTypes = ["ON_ROLL", "DSA"];
        } else {
          // If only one employment type is selected, set it for the search
          userTypes = [employmentType];
        }

        // Create an array of search promises based on the userTypes
        const searchPromises = userTypes.map((type) =>
          userSearchAPI({ where: { employmentType: type } })
        );

        // Await all the search promises and store the results
        const searchResults = await Promise.all(searchPromises);
        const userIds = searchResults
          .map((result) => result.data.data.data.map((user) => user._id))
          .flat();

        set(where, "agentId", { $in: userIds });
      }
      //LoanPolicyNumber
      if (LoanPolicyNumber) {
        set(where, "coverNotes.cn_number", LoanPolicyNumber);
      }
      //  if (LoanPolicyNumber) {
      //   if (productCategory === "VEHICLE_INSURANCE")
      //     set(where, "coverNotes.cn_number", LoanPolicyNumber)
      //   else
      //     set(where, "meta.LoanAccountNo", LoanPolicyNumber)
      // }

      setWhere(where);
      dispatch(
              excelCaseSearchAction({
                where,
                sortBy: "ts",
                sortOrder: -1,
                fullTextSearch: false,
              })
            );
      dispatch(
        caseSearchAction({
          where,
          currentPage: 0,
          sortBy: "ts",
          sortOrder: -1,
          fullTextSearch: false,
          pageLength: 50,
        })
      );
    },
    [dispatch]
  );

  const onClear = useCallback(() => {
    dispatch(caseResetAction());
    setFilterInitialValues({
      ...filterDefaultValues,
    });
  }, [dispatch]);

  const generateInvoice = useCallback(
    async (commissionId) => {
      const payload = {
        commissionId: commissionId,
        data: invoiceInitialValues,
      };
      const invoice = await caseInvoiceCreateAPI(payload);
      closeAlertDialog();
      dispatch(
        headerShowAction({
          data: "Invoice has been created successfully.",
        })
      );
    },
    [invoiceInitialValues]
  );
  const handleChange = useCallback(
    (e) => {
      const id = e.target.name;
      const checked = e.target.value;

      if (checked == "false")
        setInvoiceInitialValues([...invoiceInitialValues, id]);
      else
        setInvoiceInitialValues(
          invoiceInitialValues.filter((item) => {
            return id !== item;
          })
        );

      // setInvoiceInitialValues(id)

      // // data.push(id);
      // console.log("checked", checked);
      // console.log("invoiceInitialValues=>", invoiceInitialValues);
      // if()
      // else
      // console.log('invoiceInitialValues=>', invoiceInitialValues, data);

      return data;
    },
    [
      // dispatch,
      invoiceInitialValues,
    ]
  );

  const ExportInExcel = useMemo(() => {
    if (!excelSearchResults) {
      return [];
    }
    const results = [];
    let totalGrossAmt = 0;
    let customerAddress="NA"
    excelSearchResults.forEach((caseInfo) => {
      if(caseInfo?.caseType=="CORPORATE"){
        customerAddress = caseInfo?.customerId?.companyAddress
      }else{
        customerAddress = caseInfo?.customerId?.presentAddress
      }
      const CrossSellAmount = caseInfo.meta.crossSaleAmount || 0;
      const gstCalc = caseInfo.companyId.GSTCalc;
      const DueAmount = getPayout(caseInfo, "Due");
      const payoutAmount = getPayout(caseInfo, "Payout");
      const difference = payoutAmount - DueAmount;
      const GSTEncExc = getGSTCalc(DueAmount, gstCalc);
      const agentName =
        caseInfo.agentId.personalInfo.firstName +
        " " +
        caseInfo.agentId.personalInfo.lastName +
        "-" +
        caseInfo.agentId.employmentType;
      const amount = caseInfo.meta.loanAmount - CrossSellAmount;
      const paymentAmount = getTotalAmount(caseInfo.paymentDetails);
      const receiptAmount = getTotalAmount(caseInfo.recieptDetails);
      const customerName = `${caseInfo.customerId.firstName} ${caseInfo.customerId.lastName}`;
      totalGrossAmt += caseInfo.meta.grossLoanAmount || 0;
      const payment = caseInfo.payments[0] === undefined ? '' : caseInfo.payments[0];
      const payment_ = caseInfo.payments[1] === undefined ? '' : caseInfo.payments[1];
      const effectiveDate = new Date(caseInfo.coverNotes.effective_date);
      const expiryDate = new Date(effectiveDate.getFullYear() + 1, effectiveDate.getMonth(), effectiveDate.getDate() - 1);
      const PIDdate = new Date(caseInfo.coverNotes.cn_date);
      const EffectiveDate = new Date(caseInfo.coverNotes.effective_date);
      const thirdPartyExpDt = caseInfo.coverNotes.third_party_exp_date ? 'NA' : caseInfo.coverNotes.third_party_exp_date
      const thrdPED = new Date(thirdPartyExpDt);
      const pay1D = new Date(payment.payment_date);
      const pay2D = new Date(payment_.payment_date);
      const currD = new Date(caseInfo.ts);
      // const formattedPID = `${PIDdate.getDate()}-${(PIDdate.getMonth() + 1).toString().padStart(2, '0')}-${PIDdate.getFullYear()}`;
      const dateOptions = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      };
      const formattedExpiryDate = expiryDate.toLocaleDateString('en-GB', dateOptions);
      const formattedPID = PIDdate.toLocaleDateString('en-GB', dateOptions);
      const formattedEffD = EffectiveDate.toLocaleDateString('en-GB', dateOptions);
      const formattedTPED = thrdPED.toLocaleDateString('en-GB', dateOptions);
      const formattedCD = currD.toLocaleDateString('en-GB', dateOptions);
      results.push({
        "Name Of Customer": customerName,
        "Address": customerAddress,
        "Assigned Agent Name":
          (caseInfo.agentId?.personalInfo?.firstName || '') +
          " " +
          (caseInfo.agentId?.personalInfo?.lastName || ''),
        "Employment Type": caseInfo?.agentId?.employmentType || '',
        "Reporting Manager Name":
          (caseInfo.reportingManagerId?.personalInfo?.firstName || '') +
          " " +
          (caseInfo.reportingManagerId?.personalInfo?.lastName || ''),
        "Customer Mobile": caseInfo.customerId.phone,
        "Manufacturer/Company": caseInfo.companyId.companyName,
        "Business Type": caseInfo.vehicleStatus,
        "Vehicle Name": caseInfo.meta.vehicleProductId.productName,
        "Policy Issue Date": formattedPID !== "Invalid Date" ? formattedPID : 'NA',
        "Model Year": caseInfo.meta.vehicleModelYear,
        "Vehicle Number": caseInfo.meta.vehicleNumber,
        "Policy Number": caseInfo.coverNotes.cn_number,
        "Effective Date": formattedEffD ? formattedEffD : 'NA',
        "Expiry Date": expiryDate !== "Invalid Date" ? formattedExpiryDate : 'NA',
        "Third-Party Expiry Date": formattedTPED !== "Invalid Date" ? formattedTPED : 'NA',
        "Policy Type": caseInfo?.policyType?.masterName ? caseInfo?.policyType?.masterName : 'NA',
        "Total Policy Premium": caseInfo.coverNotes.totalPolicyPremium,
        "NCB (%)": caseInfo.coverNotes.ncbPercentage,
        "Insurance OD Premium": caseInfo.coverNotes.odPremium,
        "LOS No.": caseInfo.coverNotes.losNo,
        "Insu. Agent Code": caseInfo.coverNotes.InsUAgentCode,
        "Discount Amount Pass To Customer": caseInfo.coverNotes.discountPassToCustomer,
        "Created By": caseInfo.by.personalInfo.firstName,

        Date: formattedCD ? formattedCD : 'NA',
      });
    });

    return results;
  }, [
    excelSearchResults,
    currentProductCategory,
    currentActivityAssignedDateFrom,
    currentActivityAssignedDateTill,
    currentCompany,
  ]);
  const viewRemarks = async (id) => {
    openAlertDialog("remarks");
    if (!id) return;

    let where = {
      refId: id,
      deleted: false,
      source: "cases",
    };

    const {
      data: {
        data: { data: remarks },
      },
    } = await remarkSearchAPI({
      where,
      sortBy: "ts",
      pageLength: 0,
      currentPage: 1,
      autopopulate: false,
    });
    setRemarksDetails(remarks);
  };

  // EDIT
  const editClick = useCallback(
    (record) => {
      dispatch(caseEditAction(record));
      history.push(RoutingUtil.caseManagerUrl());
    },
    [dispatch, caseEditAction, history]
  );

  return (
    <div>
      <Formik
        onSubmit={onSearchSubmit}
        onClear={onClear}
        enableReinitialize
        initialValues={filterInitialValues}
      // validationSchema={}
      >
        {(formikProps) => (
          <RenderFilters
            // forceRefreshSearchContainer={forceRefreshSearchContainer}
            onClear={onClear}
            {...formikProps}
            activityList={activitiesFromSearch}
            userType={userType}
            ExportInExcel={ExportInExcel}
            handleChange={handleChange}
            generateInvoice={generateInvoice}
            history={history}
            onPageChange={onPageChange}
            alertModalClass={alertModalClass}
            alertDisplay={alertDisplay}
            openAlertDialog={openAlertDialog}
            viewRemarks={viewRemarks}
            editClick={editClick}
            grossAmount={grossAmount}
            grossODPremium={grossODPremium}
          />
        )}
      </Formik>
      {/* <div className={`modal fade ${(invoiceModal) ? 'show' : ''}`} id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"> */}
      <div
        className={`modal fade ${remarksModalClass}`}
        id="authAlert"
        style={{
          display: `${remarksDisplay}`,
          overflowY: "scroll",
          opacity: "1",
          background: "rgba(0, 0, 0, 0.5)",
        }}
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                View Remarks
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => closeAlertDialog("remarks")}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group col-md-12">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">Sr. No.</th>
                      <th scope="col">Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {remarksDetails.map((remark, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{remark.text}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => closeAlertDialog("remarks")}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RptInsuranceAlertList;
